// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    background-color: #013020;
    color: white;
    overflow-x: hidden;
}

.home-page-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
}

.content {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    align-items: center;
}

.left-section, .right-section {
    flex: 1 1;
    padding: 1rem;
    width: 100%;
    text-align: center;
}

.heading, .instructor-heading {
    font-size: 2.2rem;
    margin-bottom: 1.2rem;
    font-weight: bold;
    color: #f2cd01;
}

.subtitle, .instructor-subtitle {
    font-size: 1.1rem;
    line-height: 1.6;
    max-width: 100%;
    word-wrap: break-word;
    color: #ffffff;
    opacity: 0.9;
    margin-bottom: 2rem;
}

.stats-section {
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    margin-top:0px; /* Reduced from 30px */
    justify-content: center;
    align-items: center;
}

.stat-circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    margin-right: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    flex-shrink: 0;
}

.stat-number {
    font-size: 1.3rem;
    font-weight: bold;
    color: black;
}

.stat-label {
    font-size: 1.1rem;
    margin-right: 5px;
    color: #ffffff;
    opacity: 0.9;
    flex-shrink: 0;
    white-space: nowrap;
}

.search-courses-button, .search-instructors-button {
    margin-top: 20px;
    padding: 12px 24px;
    background-color: #f2cd01;
    color: #000;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: bold;
    transition: background-color 0.3s ease;
    align-self: center;
}

.search-courses-button:hover, .search-instructors-button:hover {
    background-color: #ddb901;
}

.right-section {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.right-section svg, .instructor-svg {
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 400px;
    overflow: hidden;
}

.course-text {
    font-family: monospace;
    font-size: 1rem;
    font-weight: bold;
}

.course-item {
    font-style: italic;
}

.most-enrolled-courses-text {
    font-size: 1rem;
    margin-top: 1rem;
    color: #ffffff;
    opacity: 0.7;
    font-style: italic;
    text-align: center;
}
.instructor-text {
    font-size: 1rem;
    margin-top: -40px; /* Reduced from 1rem */
    color: #ffffff;
    opacity: 0.7;
    font-style: italic;
    text-align: center;
}

.instructor-content {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
}

.instructor-text-content, .instructor-svg-container {
    width: 100%;
    text-align: center;
}

.instructor-svg-container {
    margin-top: 1rem !important;
}

@keyframes scrollUp {
    0% { transform: translateY(0); }
    100% { transform: translateY(-600px); }
}

@keyframes scrollDown {
    0% { transform: translateY(-600px); }
    100% { transform: translateY(0); }
}

.column {
    animation: 35s linear infinite;
}

.column-0 { animation-name: scrollUp; }
.column-1 { animation-name: scrollDown; }
.column-2 { animation-name: scrollUp; }
.column-3 { animation-name: scrollDown; }

/* Tablet and up */
@media (min-width: 768px) {
    .content {
        flex-direction: row;
        padding: 2rem;
        justify-content: space-between;
        align-items: flex-start;
        gap: 30px;
        margin-top: 0;
    }

    .left-section, .right-section {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        max-width: 50%;
        text-align: left;
    }

    .heading, .instructor-heading {
        font-size: 2.4rem;
    }

    .subtitle, .instructor-subtitle {
        font-size: 1.2rem;
    }

    .stats-section {
        justify-content: flex-start;
    }

    .most-enrolled-courses-text {
        margin-left: 60px;
        text-align: left;
    }

    .instructor-text {
        text-align: right;
        margin-right: 60px;
    }

    .instructor-content {
        flex-direction: row;
        align-items: flex-start;
    }

    .instructor-svg-container {
        margin-top: 4.5rem;
    }

    .instructor-text-content, .instructor-svg-container {
        width: 50%;
    }
}

/* Desktop specific adjustments */
@media (min-width: 1025px) {
    .content {
        margin-top: -40px;
        padding: 3rem;
    }

    .instructor-svg-container {
        margin-top: 4.5rem;
    }

    .stats-section {
        margin-top: -20px;
    }

    .left-section {
        padding-right: 2rem;
    }

    .right-section {
        padding-left: 2rem;
    }

    .right-section svg {
        margin-top: 2rem;
    }

    .search-courses-button,
    .search-instructors-button {
        align-self: flex-start;
    }

    .most-enrolled-courses-text {
        align-self: flex-start;
        margin-left: 0;
    }

    .instructor-text {
        margin-right: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/HomePage.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,cAAc,EAAE,sBAAsB;IACtC,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB,EAAE,sBAAsB;IACzC,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,KAAK,wBAAwB,EAAE;IAC/B,OAAO,6BAA6B,EAAE;AAC1C;;AAEA;IACI,KAAK,6BAA6B,EAAE;IACpC,OAAO,wBAAwB,EAAE;AACrC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,YAAY,wBAAwB,EAAE;AACtC,YAAY,0BAA0B,EAAE;AACxC,YAAY,wBAAwB,EAAE;AACtC,YAAY,0BAA0B,EAAE;;AAExC,kBAAkB;AAClB;IACI;QACI,mBAAmB;QACnB,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;QACvB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,SAAO;QACP,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,2BAA2B;QAC3B,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,iCAAiC;AACjC;IACI;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    font-family: Arial, sans-serif;\n    background-color: #013020;\n    color: white;\n    overflow-x: hidden;\n}\n\n.home-page-wrapper {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 20px;\n    box-sizing: border-box;\n    align-items: center;\n}\n\n.left-section, .right-section {\n    flex: 1;\n    padding: 1rem;\n    width: 100%;\n    text-align: center;\n}\n\n.heading, .instructor-heading {\n    font-size: 2.2rem;\n    margin-bottom: 1.2rem;\n    font-weight: bold;\n    color: #f2cd01;\n}\n\n.subtitle, .instructor-subtitle {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    max-width: 100%;\n    word-wrap: break-word;\n    color: #ffffff;\n    opacity: 0.9;\n    margin-bottom: 2rem;\n}\n\n.stats-section {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 20px;\n    margin-top:0px; /* Reduced from 30px */\n    justify-content: center;\n    align-items: center;\n}\n\n.stat-circle {\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    text-align: center;\n    margin-right: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    flex-shrink: 0;\n}\n\n.stat-number {\n    font-size: 1.3rem;\n    font-weight: bold;\n    color: black;\n}\n\n.stat-label {\n    font-size: 1.1rem;\n    margin-right: 5px;\n    color: #ffffff;\n    opacity: 0.9;\n    flex-shrink: 0;\n    white-space: nowrap;\n}\n\n.search-courses-button, .search-instructors-button {\n    margin-top: 20px;\n    padding: 12px 24px;\n    background-color: #f2cd01;\n    color: #000;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 1.1rem;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n    align-self: center;\n}\n\n.search-courses-button:hover, .search-instructors-button:hover {\n    background-color: #ddb901;\n}\n\n.right-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.right-section svg, .instructor-svg {\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    max-height: 400px;\n    overflow: hidden;\n}\n\n.course-text {\n    font-family: monospace;\n    font-size: 1rem;\n    font-weight: bold;\n}\n\n.course-item {\n    font-style: italic;\n}\n\n.most-enrolled-courses-text {\n    font-size: 1rem;\n    margin-top: 1rem;\n    color: #ffffff;\n    opacity: 0.7;\n    font-style: italic;\n    text-align: center;\n}\n.instructor-text {\n    font-size: 1rem;\n    margin-top: -40px; /* Reduced from 1rem */\n    color: #ffffff;\n    opacity: 0.7;\n    font-style: italic;\n    text-align: center;\n}\n\n.instructor-content {\n    margin-top: 40px;\n    display: flex;\n    flex-direction: column;\n}\n\n.instructor-text-content, .instructor-svg-container {\n    width: 100%;\n    text-align: center;\n}\n\n.instructor-svg-container {\n    margin-top: 1rem !important;\n}\n\n@keyframes scrollUp {\n    0% { transform: translateY(0); }\n    100% { transform: translateY(-600px); }\n}\n\n@keyframes scrollDown {\n    0% { transform: translateY(-600px); }\n    100% { transform: translateY(0); }\n}\n\n.column {\n    animation: 35s linear infinite;\n}\n\n.column-0 { animation-name: scrollUp; }\n.column-1 { animation-name: scrollDown; }\n.column-2 { animation-name: scrollUp; }\n.column-3 { animation-name: scrollDown; }\n\n/* Tablet and up */\n@media (min-width: 768px) {\n    .content {\n        flex-direction: row;\n        padding: 2rem;\n        justify-content: space-between;\n        align-items: flex-start;\n        gap: 30px;\n        margin-top: 0;\n    }\n\n    .left-section, .right-section {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n        max-width: 50%;\n        text-align: left;\n    }\n\n    .heading, .instructor-heading {\n        font-size: 2.4rem;\n    }\n\n    .subtitle, .instructor-subtitle {\n        font-size: 1.2rem;\n    }\n\n    .stats-section {\n        justify-content: flex-start;\n    }\n\n    .most-enrolled-courses-text {\n        margin-left: 60px;\n        text-align: left;\n    }\n\n    .instructor-text {\n        text-align: right;\n        margin-right: 60px;\n    }\n\n    .instructor-content {\n        flex-direction: row;\n        align-items: flex-start;\n    }\n\n    .instructor-svg-container {\n        margin-top: 4.5rem;\n    }\n\n    .instructor-text-content, .instructor-svg-container {\n        width: 50%;\n    }\n}\n\n/* Desktop specific adjustments */\n@media (min-width: 1025px) {\n    .content {\n        margin-top: -40px;\n        padding: 3rem;\n    }\n\n    .instructor-svg-container {\n        margin-top: 4.5rem;\n    }\n\n    .stats-section {\n        margin-top: -20px;\n    }\n\n    .left-section {\n        padding-right: 2rem;\n    }\n\n    .right-section {\n        padding-left: 2rem;\n    }\n\n    .right-section svg {\n        margin-top: 2rem;\n    }\n\n    .search-courses-button,\n    .search-instructors-button {\n        align-self: flex-start;\n    }\n\n    .most-enrolled-courses-text {\n        align-self: flex-start;\n        margin-left: 0;\n    }\n\n    .instructor-text {\n        margin-right: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
